import React from 'react'

const CardHeader = props => (
    <div className="card-header">
        { props.children }
    </div>
)

export default CardHeader